import DialogComponent from '../widgets/dialog/DialogComponent';

class FirmwareCreateDialog extends DialogComponent {

  state = { type: '' }

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <input
              type="text"
              placeholder="Firmware Type"
              className="input-app input-lg ltr text-center"
              onChange={(e) => this.setState({ type: e.target.value })} />
          </div>
        </div>
        <hr />
        <div className="col-12 d-flex">
          <button
            onClick={() => { this.resolve(this.state); this.close(); }}
            className="btn btn-app btn-block">ایجاد کردن</button>
        </div>
      </div>
    );
  }
}

export default FirmwareCreateDialog;
